import { Injectable }               from '@angular/core';
import { StsPortalStatusService }   from './sts-portal-status.service';
import { StsTenantService }         from './sts-tenant.service';
import { StsPortalStatus }          from '../models/sts-portal-status';
import { StsTenant }                from '../models/sts-tenant.model';

@Injectable()
export class StsSessionTimeoutService {

  private timeoutHandle: any;
  private portalRefreshFrequency = 900000; // default 15 mins
  private uiRefreshFrequency = 5000;
  private timeout: number = 4 * 60 * 1000; // default 4 mins
  private redirectUrl = '/Account/Signout';
  private expirationDate: number;

  constructor(private portalStatusService: StsPortalStatusService
            , private tenantService: StsTenantService) {
  }


  // todo: rename to start()
  public setTimeout() {

    this.portalStatusService.getPortalStatus().subscribe((stsPortalStatus: StsPortalStatus) => {
      this.tenantService.getTenantSource().subscribe((tenant: StsTenant) => {

        this.timeout = tenant.sessionTimeout;

        if ( this.timeout === undefined || this.timeout == null) {
          this.timeout = 300000; // default 5 mins
        }

        if ( stsPortalStatus.isMemberPortal &&
           !stsPortalStatus.isLoggedIn &&
            stsPortalStatus.isSelfRegFlow ) {

          // Member self reg flow, redirect back to Step 1, all esle to /Account/Signout
          this.redirectUrl = '/Tools/AccessTool/ASRegisterUserTool';
        }

        console.log('Session timeout configuration => redirectUrl = [' + this.redirectUrl + '] timeout = ' + this.timeout);

        if ( this.timeoutHandle !== undefined) {
          console.log('Restarting timeout timer');
          window.clearTimeout(this.timeoutHandle);
        }

        // TEMP/DEBUGGING OVERRIDE
        // this.timeout = 5000;
        // this.uiRefreshFrequency = 1000;
        // this.portalRefreshFrequency = 1000;

        // Calculates the time when the session should expire
        // (based on current time + session timeout settings)
        this.expirationDate = (new Date()).getTime() + this.timeout;

        // UI TIMER
        //
        this.timeoutHandle = setInterval(() => {
          // console.log("Checking if session has expired");
          if ( (new Date()).getTime() > this.expirationDate ) {
            console.log('Session expired, redirecting to => ' + this.redirectUrl);
            this.cancelTimeout();
            location.href = this.redirectUrl;
          }
        }, this.uiRefreshFrequency);

        this.keepAlive();
      });
    });
  }

  public cancelTimeout() {
    console.log('Cancelling session time out timer');
    window.clearTimeout(this.timeoutHandle);
    this.timeoutHandle = undefined;
  }

  public slideTimer() {
    if ( this.timeoutHandle !== undefined ) {
      console.log('Mouse moved, sliding time!');
      this.expirationDate = (new Date()).getTime() + this.timeout;
    }
  }

  public keepAlive() {
    setInterval(() => {
      this.tenantService.getTenantSource().subscribe(() => {
          // Forces the portal session to keep alive, and if it actually expired,
          // this will force us out of the application
          console.log('Called portal to keep backend session alive');
      });
    }, this.portalRefreshFrequency);
  }

}
